/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_News_EmptyInputs */

const en_us2_community_news_empty = /** @type {(inputs: Community_News_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing new here yet.`)
};

const pt_br2_community_news_empty = /** @type {(inputs: Community_News_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada novo por aqui ainda.`)
};

const es_419_community_news_empty = /** @type {(inputs: Community_News_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay nada nuevo aquí.`)
};

const pt_pt2_community_news_empty = /** @type {(inputs: Community_News_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não há nada de novo por aqui.`)
};

const fr_fr2_community_news_empty = /** @type {(inputs: Community_News_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rien de nouveau pour l'instant.`)
};

const de_de2_community_news_empty = /** @type {(inputs: Community_News_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier gibt es noch nichts Neues.`)
};

const it_it2_community_news_empty = /** @type {(inputs: Community_News_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora niente di nuovo qui.`)
};

/**
* | output |
* | --- |
* | "Nothing new here yet." |
*
* @param {Community_News_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_news_empty = /** @type {((inputs?: Community_News_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_News_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_news_empty(inputs)
	if (locale === "es-419") return es_419_community_news_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_community_news_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_community_news_empty(inputs)
	if (locale === "de-DE") return de_de2_community_news_empty(inputs)
	if (locale === "it-IT") return it_it2_community_news_empty(inputs)
	return en_us2_community_news_empty(inputs)
});
export { community_news_empty as "community.news_empty" }